import React from 'react';
import { Link } from 'react-router-dom';

const Header = ({ user, tenant, unreadNotifications, onToggleSidebar, onToggleNotifications, onLogout }) => {
  const [userMenuOpen, setUserMenuOpen] = React.useState(false);

  const copyWechat = () => {
    navigator.clipboard.writeText('iniubei').then(() => {
      alert('商务合作微信号 iniubei 已复制到剪贴板');
    });
  };

  return (
    <header className="bg-white shadow-sm z-10">
      <div className="max-w-full mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
          <div className="flex items-center">
            <button
              onClick={onToggleSidebar}
              className="p-2 rounded-md text-gray-600 hover:text-gray-900 hover:bg-gray-100 focus:outline-none lg:hidden"
            >
              <i className="fa fa-bars"></i>
            </button>
            <div className="flex-shrink-0 flex items-center ml-2 lg:ml-0">
              {tenant.logo_url ? (
                <img
                  className="h-8 w-auto"
                  src={tenant.logo_url}
                  alt={`${tenant.name} Logo`}
                />
              ) : (
                <div className="h-8 w-8 bg-primary rounded-md flex items-center justify-center">
                  <i className="fa fa-building text-white"></i>
                </div>
              )}
              <span className="ml-2 text-lg font-semibold text-gray-900 hidden sm:block">
                {tenant.name}
              </span>
            </div>
          </div>
          
          <div className="flex items-center">
            {/* 商务合作微信入口 */}
            <button
              onClick={copyWechat}
              className="hidden sm:flex items-center gap-1 px-3 py-1.5 mr-3 bg-green-50 text-green-600 text-sm rounded-lg hover:bg-green-100 transition-colors"
            >
              <i className="fa fa-wechat"></i>
              <span>商务合作：iniubei</span>
            </button>

            {/* 通知按钮 */}
            <div className="flex-shrink-0 relative">
              <button
                onClick={onToggleNotifications}
                className="p-2 rounded-full text-gray-600 hover:text-gray-900 hover:bg-gray-100 focus:outline-none"
              >
                <i className="fa fa-bell"></i>
                {unreadNotifications > 0 && (
                  <span className="absolute top-0 right-0 block h-4 w-4 rounded-full bg-danger text-white text-xs font-bold flex items-center justify-center">
                    {unreadNotifications > 9 ? '9+' : unreadNotifications}
                  </span>
                )}
              </button>
            </div>
            
            {/* 用户菜单 */}
            <div className="ml-4 relative">
              <div>
                <button
                  onClick={() => setUserMenuOpen(!userMenuOpen)}
                  className="flex items-center text-sm rounded-full focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary"
                >
                  <span className="sr-only">打开用户菜单</span>
                  {user.avatar_url ? (
                    <img
                      className="h-8 w-8 rounded-full"
                      src={user.avatar_url}
                      alt={user.full_name || user.username}
                    />
                  ) : (
                    <div className="h-8 w-8 rounded-full bg-primary text-white flex items-center justify-center">
                      <i className="fa fa-user"></i>
                    </div>
                  )}
                  <span className="ml-2 text-sm font-medium text-gray-700 hidden md:block">
                    {user.full_name || user.username}
                  </span>
                  <i className="fa fa-chevron-down ml-1 text-gray-400"></i>
                </button>
              </div>
              
              {/* 用户下拉菜单 */}
              {userMenuOpen && (
                <div className="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg py-1 z-50">
                  <div className="px-4 py-2 border-b border-gray-100">
                    <p className="text-sm font-medium text-gray-900">{user.full_name || user.username}</p>
                    <p className="text-xs text-gray-500">{user.position || user.role}</p>
                  </div>
                  <Link
                    to="/system/profile"
                    className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                    onClick={() => setUserMenuOpen(false)}
                  >
                    <i className="fa fa-user mr-2"></i> 个人资料
                  </Link>
                  <Link
                    to="/system/settings"
                    className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                    onClick={() => setUserMenuOpen(false)}
                  >
                    <i className="fa fa-cog mr-2"></i> 设置
                  </Link>
                  <button
                    onClick={copyWechat}
                    className="block w-full text-left px-4 py-2 text-sm text-green-600 hover:bg-green-50"
                  >
                    <i className="fa fa-wechat mr-2"></i> 商务合作微信：iniubei
                  </button>
                  <button
                    onClick={() => {
                      setUserMenuOpen(false);
                      onLogout();
                    }}
                    className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                  >
                    <i className="fa fa-sign-out mr-2"></i> 退出登录
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;